import { addDays, eachDayOfInterval } from '../../../helpers/date'

export const getLeaveOfAbsencesOverviewCalendarDays = (startDate: Date): Date[] => (
    eachDayOfInterval({ start: startDate, end: addDays(startDate, 48) })
)
